import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import authservices from "../services/authservices";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const SubFooter = () => {
  const [loginCheck, setloginCheck] = useState(false);
  const [siteDatacomes, setSiteData] = useState("");
  const [subscribePlans, setsubscribePlans] = useState([]);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    getSitedata();
    getAllPlans();
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getAllPlans = async () => {
    try {
      const data = await authservices.getAllPlans();
      if (data.status == true) {
        setsubscribePlans(data.data);
        // console.log(data, "=-=-=get getAllPlans =-=-", data.data);
      }
    } catch (error) {}
  };

  //   terms of service
  const [termsOpen, setTermsOpen] = useState(false);
  const handleTermsOpen = () => setTermsOpen(true);
  const handleTermsClose = () => setTermsOpen(false);

  //   privacy and cookies policy
  const [cookiesOpen, setCookiesOpen] = useState(false);
  const handleCookiesOpen = () => setCookiesOpen(true);
  const handleCookiesClose = () => setCookiesOpen(false);
  return (
    <>
      {" "}
      <footer className="bn-footer" id="contact">
        <div className="container-fluid container-lg">
          <section className="row mx-0 bn-footer-row g-4 g-lg-1">
            <div className="col-lg-5 col-sm-6 col-12">
              <div className="bn_footer_lft_flx">
                <div>
                  <img
                    src={require("./img/footer-logo.webp")}
                    alt=""
                    className="bn-footer-logo"
                  />
                  <p className="bn-footer-logo-content">
                    {t("AIPoweredCryptoTrading")}
                  </p>
                </div>
                <p className="bn-footer-logo-content">
                  {t("OperatedBy")}
                  <span className="bn-footer-logo-content bn_footer_blk">
                    {t("BlockBond")}
                  </span>
                  {t("Finland")}
                  <span className="bn-footer-logo-content bn_footer_blk">
                    {t("NonCustodialSoftware")}
                  </span>
                  <span className="bn-footer-logo-content bn_footer_blk">
                    {t("Contact")}
                  </span>
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-6">
              <h6 className="bn-footer-link-title">{t("Explore")}</h6>
              <ul className="bn-footer-lists">
                <li>
                  <a
                    className="bn-footer-links cursor-pointer"
                    href="/privacy-cookies-policy"
                    target="_blank"
                  >
                    {t("Policy")}
                  </a>
                </li>
                <li>
                  <a
                    className="bn-footer-links cursor-pointer"
                    href="/terms-of-service"
                    target="_blank"
                  >
                    {t("TermsOfService")}
                  </a>
                </li>
                <li>
                  <a
                    href="/disclaimer"
                    target="_blank"
                    className="bn-footer-links"
                  >
                    {t("Disclaimer")}
                  </a>
                </li>
                <li>
                  <a
                    href="/affiliate-terms"
                    target="_blank"
                    className="bn-footer-links"
                  >
                    {t("AffiliateTerms")}
                  </a>
                </li>
                <li>
                  <a
                    href="/api-key"
                    className="bn-footer-links"
                    target="_blank"
                  >
                    {t("APIKey")}
                  </a>
                </li>
                <li>
                  <a
                    href="/binarge-academy"
                    className="bn-footer-links"
                    target="_blank"
                  >
                    {t("BinargeAcademy")}
                  </a>
                </li>
                <li>
                  <a
                    href="/strategy"
                    className="bn-footer-links"
                    target="_blank"
                  >
                    {t("Strategies")}
                  </a>
                </li>
              </ul>
            </div>
            {/* <div className="col-lg-2 col-sm-3 col-6">
              <div className="bn_footer_pl">
                <h6 className="bn-footer-link-title">Quick Links</h6>
                <ul className="bn-footer-lists">
                  <li>
                    <a href="#home" className="bn-footer-links">
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#pricing" className="bn-footer-links">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a href="#how-it-works" className="bn-footer-links">
                      How It Works
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-lg-2 col-sm-6 col-6">
              <h6 className="bn-footer-link-title">{t("SupportHead")}</h6>
              <ul className="bn-footer-lists">
                <li>
                  <Link
                    to={loginCheck ? "/support" : "/login"}
                    className="bn-footer-links"
                  >
                    {t("HelpCenter")}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-sm-6 col-6">
              <h6 className="bn-footer-link-title">{t("Social")}</h6>
              <ul className="bn-footer-icon-wrap">
                <li>
                  <a target="_blank" href={siteDatacomes.instagram}>
                    <img src={require("./img/instagram.webp")} alt="" />
                  </a>
                </li>
                <li>
                  <a target="_blank" href={siteDatacomes.twitter}>
                    <img src={require("./img/x.webp")} alt="" />
                  </a>
                </li>
                <li>
                  <a target="_blank" href={siteDatacomes.telegram}>
                    <img src={require("./img/telegram.webp")} alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </div>

        <section className="bn-copyrights">
          <p className="bn-copyrights-txt">&copy;{t("AllRightsReserved")}</p>
        </section>

        {/* Terms of service popup */}
        <Modal
          keepMounted
          open={termsOpen}
          onClose={handleTermsClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="hd_terms_box">
            <div className="hd_contact_box_inner">
              <div className="hd_terms_top">
                <h6>{t("BinargeTermsOfService")}</h6>
                <span onClick={handleTermsClose}>
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </div>

              <div className="hd_terms_main">
                <div className="contentpage">
                  <h3>1. {t("Introduction")} </h3>
                  {/* <h4>NOTICE:</h4> */}

                  <p>{t("WelcomeToBinarge")}</p>

                  <h3>2. {t("ServiceDescription")}</h3>

                  <p>{t("CryptocurrencyTrading")}</p>

                  <h3>3. {t("UserEligibility")}</h3>
                  <p>{t("YouMustBeLeast")}</p>

                  <h3>4.{t("AccountAndSecurity")}</h3>
                  <p>{t("YouAreResponsible")} </p>

                  <h3>5. {t("APIConnections")}</h3>

                  <p>{t("BinargeOperates")}</p>

                  <h3>6. {t("Subscription")}</h3>
                  <p>{t("BinargeOffers")}</p>

                  <h3>7. {t("ProfitSharing")}</h3>
                  <p>{t("BinargeUses")}</p>

                  <h3>8. {t("RiskDisclaimer")}</h3>
                  <p>{t("TradingCryptocurrencies")}</p>

                  <h3>9.{t("NoFinancialAdvice")}</h3>
                  <p>{t("FinanciaAdvisor")}</p>

                  <h3>10. {t("Termination")}</h3>
                  <p>{t("WeReserveTheRight")}</p>

                  <h3>11. {t("ChangesToTerms")}</h3>
                  <p>{t("BinargeMayRevise")}</p>

                  <h3>12. {t("ContactInformation")}</h3>
                  <p>{t("ForQuestions")}</p>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        {/* privacy and cookies popup */}
        <Modal
          keepMounted
          open={cookiesOpen}
          onClose={handleCookiesClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="hd_terms_box">
            <div className="hd_contact_box_inner">
              <div className="hd_terms_top">
                <h6>{t("BinargePrivacy")}</h6>
                <span onClick={handleCookiesClose}>
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </div>

              <div className="hd_terms_main">
                <div className="contentpage">
                  <h3>1. {t("Introduction")}</h3>
                  <p>{t("HowBinarge")}</p>

                  <h3>2. {t("DataWeCollect")}</h3>

                  <ul>
                    <li>{t("PersonalInformation")}</li>
                    <li>{t("UsageInformation")}</li>
                    <li>{t("AccountDetails")}</li>
                  </ul>

                  <h3>3. {t("HowWeUseInformation")}</h3>

                  <ul>
                    <li>{t("ToCreate")}</li>
                    <li>{t("experience")}</li>
                    <li>{t("ProvideSupport")}</li>
                    <li>{t("platformPerformance")}</li>
                    <li>{t("toSend")}</li>
                  </ul>

                  <h3>4. {t("Cookies")}</h3>

                  <p>{t("BinargeUsesCookies")}</p>
                  <p>{t("TypesOfCookiesUsed")}</p>
                  <ul>
                    <li>{t("EssentialCookies")}</li>
                    <li>{t("AnalyticalCookies")}</li>
                    <li>{t("MarketingCookies")}</li>
                  </ul>

                  <h3>5. {t("GDPR")}</h3>
                  <p>{t("WeProcessYourData")}</p>

                  <h3>6.{t("ThirdParty")}</h3>
                  <p>{t("Brevo")}</p>

                  <h3>7. {t("DataSecurity")}</h3>
                  <p>{t("appropriate")}</p>

                  <h3>8. {t("YourRights")}</h3>
                  <p>{t("UnderGDPR")}</p>
                  <ul>
                    <li>{t("AccessYourPersonalData")}</li>
                    <li>{t("RequestCorrection")}</li>
                    <li>{t("Withdraw")}</li>
                    <li>{t("complaint")}</li>
                  </ul>

                  <h3>9. {t("DataRetention")}</h3>
                  <p>{t("WeRetain")}</p>
                  <h3>10. {t("Children")}</h3>
                  <p>{t("knowinglyCollect")}</p>
                  <h3>11. {t("International")}</h3>
                  <p>{t("YourData")}</p>
                  <h3>12. {t("ChangesToThisPolicy")}</h3>
                  <p>{t("update")}</p>
                  <h3>13. {t("ContactUs")}</h3>
                  <p>{t("BinargePlatform")}</p>
                  <p>{t("IfYouHaveAnyQuestions")}</p>

                  <p>{t("email")}</p>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </footer>
    </>
  );
};

export default SubFooter;
